<template>
  <svg
    class="warning"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M9.48854 4.5501C10.6047 2.61676 13.3953 2.61676 14.5115 4.5501L21.4397 16.5501C22.5559 18.4834 21.1606 20.9001 18.9282 20.9001H5.07181C2.83939 20.9001 1.44412 18.4834 2.56033 16.5501L9.48854 4.5501Z"
      fill="#FFF1CC"
    />
    <mask
      id="path-2-outside-1_14700_101085"
      maskUnits="userSpaceOnUse"
      x="-0.83252"
      y="1.1001"
      width="25"
      height="22"
      fill="black"
    >
      <rect fill="white" x="-0.83252" y="1.1001" width="25" height="22" />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M9.48854 4.5501C10.6047 2.61676 13.3953 2.61676 14.5115 4.5501L21.4397 16.5501C22.5559 18.4834 21.1606 20.9001 18.9282 20.9001H5.07181C2.83939 20.9001 1.44412 18.4834 2.56033 16.5501L9.48854 4.5501ZM12.9526 5.4501C12.5292 4.71676 11.4708 4.71676 11.0474 5.4501L4.11918 17.4501C3.69579 18.1834 4.22503 19.1001 5.07181 19.1001H18.9282C19.775 19.1001 20.3042 18.1834 19.8808 17.4501L12.9526 5.4501Z"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M12 8.00013C12.4971 8.00013 12.9 8.37429 12.9 8.83584L12.9 13.6644C12.9 14.126 12.497 14.5001 12 14.5001C11.5029 14.5001 11.1 14.126 11.1 13.6644L11.1 8.83584C11.1 8.37429 11.503 8.00013 12 8.00013Z"
      />
      <path
        d="M13 16.5001C13 17.0524 12.5523 17.5001 12 17.5001C11.4477 17.5001 11 17.0524 11 16.5001C11 15.9478 11.4477 15.5001 12 15.5001C12.5523 15.5001 13 15.9478 13 16.5001Z"
      />
    </mask>
    <path
      class="main"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M9.48854 4.5501C10.6047 2.61676 13.3953 2.61676 14.5115 4.5501L21.4397 16.5501C22.5559 18.4834 21.1606 20.9001 18.9282 20.9001H5.07181C2.83939 20.9001 1.44412 18.4834 2.56033 16.5501L9.48854 4.5501ZM12.9526 5.4501C12.5292 4.71676 11.4708 4.71676 11.0474 5.4501L4.11918 17.4501C3.69579 18.1834 4.22503 19.1001 5.07181 19.1001H18.9282C19.775 19.1001 20.3042 18.1834 19.8808 17.4501L12.9526 5.4501Z"
    />
    <path
      class="main"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12 8.00013C12.4971 8.00013 12.9 8.37429 12.9 8.83584L12.9 13.6644C12.9 14.126 12.497 14.5001 12 14.5001C11.5029 14.5001 11.1 14.126 11.1 13.6644L11.1 8.83584C11.1 8.37429 11.503 8.00013 12 8.00013Z"
    />
    <path
      class="main"
      d="M13 16.5001C13 17.0524 12.5523 17.5001 12 17.5001C11.4477 17.5001 11 17.0524 11 16.5001C11 15.9478 11.4477 15.5001 12 15.5001C12.5523 15.5001 13 15.9478 13 16.5001Z"
    />
    <path
      class="background"
      d="M14.5115 4.5501L12.7794 5.5501V5.5501L14.5115 4.5501ZM9.48854 4.5501L11.2206 5.5501V5.5501L9.48854 4.5501ZM21.4397 16.5501L23.1717 15.5501H23.1717L21.4397 16.5501ZM2.56033 16.5501L0.828282 15.5501L2.56033 16.5501ZM11.0474 5.4501L9.31533 4.4501L9.31533 4.4501L11.0474 5.4501ZM12.9526 5.4501L14.6847 4.4501V4.4501L12.9526 5.4501ZM4.11918 17.4501L5.85123 18.4501L5.85123 18.4501L4.11918 17.4501ZM19.8808 17.4501L21.6129 16.4501L21.6129 16.4501L19.8808 17.4501ZM12.9 8.83584L14.9 8.83586V8.83584H12.9ZM12.9 13.6644L10.9 13.6644V13.6644H12.9ZM11.1 13.6644L9.09997 13.6644V13.6644H11.1ZM11.1 8.83584L13.1 8.83586V8.83584H11.1ZM16.2435 3.5501C14.3575 0.283432 9.6425 0.28343 7.75648 3.5501L11.2206 5.5501C11.567 4.9501 12.433 4.9501 12.7794 5.5501L16.2435 3.5501ZM23.1717 15.5501L16.2435 3.5501L12.7794 5.5501L19.7076 17.5501L23.1717 15.5501ZM18.9282 22.9001C22.7002 22.9001 25.0577 18.8168 23.1717 15.5501L19.7076 17.5501C20.054 18.1501 19.621 18.9001 18.9282 18.9001V22.9001ZM5.07181 22.9001H18.9282V18.9001H5.07181V22.9001ZM0.828282 15.5501C-1.05773 18.8168 1.29979 22.9001 5.07181 22.9001V18.9001C4.37899 18.9001 3.94597 18.1501 4.29238 17.5501L0.828282 15.5501ZM7.75648 3.5501L0.828282 15.5501L4.29238 17.5501L11.2206 5.5501L7.75648 3.5501ZM12.7794 6.4501C12.433 7.0501 11.567 7.0501 11.2206 6.4501L14.6847 4.4501C13.4915 2.38343 10.5085 2.38343 9.31533 4.4501L12.7794 6.4501ZM5.85123 18.4501L12.7794 6.4501L9.31533 4.4501L2.38713 16.4501L5.85123 18.4501ZM5.07181 17.1001C5.76463 17.1001 6.19764 17.8501 5.85123 18.4501L2.38713 16.4501C1.19394 18.5168 2.68542 21.1001 5.07181 21.1001V17.1001ZM18.9282 17.1001H5.07181V21.1001H18.9282V17.1001ZM18.1488 18.4501C17.8024 17.8501 18.2354 17.1001 18.9282 17.1001V21.1001C21.3146 21.1001 22.8061 18.5168 21.6129 16.4501L18.1488 18.4501ZM11.2206 6.4501L18.1488 18.4501L21.6129 16.4501L14.6847 4.4501L11.2206 6.4501ZM14.9 8.83584C14.9 7.13272 13.4595 6.00013 12 6.00013V10.0001C11.5347 10.0001 10.9 9.61585 10.9 8.83584H14.9ZM14.9 13.6644L14.9 8.83586L10.9 8.83582L10.9 13.6644L14.9 13.6644ZM12 16.5001C13.4594 16.5001 14.9 15.3675 14.9 13.6644H10.9C10.9 12.8844 11.5346 12.5001 12 12.5001V16.5001ZM9.09997 13.6644C9.09997 15.3675 10.5405 16.5001 12 16.5001V12.5001C12.4653 12.5001 13.1 12.8844 13.1 13.6644H9.09997ZM9.10002 8.83582L9.09997 13.6644L13.1 13.6644L13.1 8.83586L9.10002 8.83582ZM12 6.00013C10.5406 6.00013 9.10002 7.13272 9.10002 8.83584H13.1C13.1 9.61585 12.4654 10.0001 12 10.0001V6.00013ZM11 16.5001C11 15.9478 11.4477 15.5001 12 15.5001V19.5001C13.6569 19.5001 15 18.157 15 16.5001H11ZM12 15.5001C12.5523 15.5001 13 15.9478 13 16.5001H9.00002C9.00002 18.157 10.3432 19.5001 12 19.5001V15.5001ZM13 16.5001C13 17.0524 12.5523 17.5001 12 17.5001V13.5001C10.3432 13.5001 9.00002 14.8433 9.00002 16.5001H13ZM12 17.5001C11.4477 17.5001 11 17.0524 11 16.5001H15C15 14.8433 13.6569 13.5001 12 13.5001V17.5001Z"
      mask="url(#path-2-outside-1_14700_101085)"
    />
  </svg>
</template>

<script>
export default {
  name: 'WarningIcon',
};
</script>

<style lang="scss">
@import '@/assets/css/variables.scss';

svg.warning {
  .main {
    fill: $main-yellow-color;
  }
  .background {
    fill: $background-yellow-color;
  }
}
</style>
